export default __webpack_public_path__ + "static/media/tss-logo.0ef3fe8c.png";